import {type RefObject, useLayoutEffect, useState} from 'react';
import useResizeObserver from 'use-resize-observer';

import {useTextWidth} from './useTextWidth';

type UseIsTextOverflowingOpts = {
  /* The text to measure */
  text: string;
  /* Ref to the parent element that will be measured */
  parentDomRef: RefObject<HTMLElement>;
};

/**
 * Hook that determines if the given text is overflowing its parent element.
 * @param text
 * @param parentDomRef
 */
export function useIsTextOverflowing({
  text,
  parentDomRef,
}: UseIsTextOverflowingOpts): boolean {
  const [isTextOverflowing, setIsTextOverflowing] = useState(true);
  const {width: parentWidth} = useResizeObserver({ref: parentDomRef});

  const textWidth = useTextWidth({text: text.trim(), parentDomRef});
  useLayoutEffect(() => {
    if (parentWidth == null) {
      return;
    }
    setIsTextOverflowing(textWidth > parentWidth);
  }, [parentWidth, text, textWidth]);

  return isTextOverflowing;
}
